import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { FormEventContext, useFormEvent } from "./utils.js";
const FormProviderInner = ({ children, group, name, emit })=>/*#__PURE__*/ jsx(FormEventContext.Provider, {
        value: {
            group,
            name,
            emit
        },
        children: children
    });
const FormItemProviderInner = ({ children, ...props })=>{
    const record = useFormEvent();
    return /*#__PURE__*/ jsx(FormEventContext.Provider, {
        value: {
            ...record,
            ...props
        },
        children: children
    });
};
const FormProvider = /*#__PURE__*/ memo(FormProviderInner);
const FormItemProvider = /*#__PURE__*/ memo(FormItemProviderInner);
if ('production' !== process.env.NODE_ENV) {
    FormProvider.displayName = 'FormProvider';
    FormItemProvider.displayName = 'FormItemProvider';
}
export { FormItemProvider, FormProvider };
